function addObserver(
  observedElement,
  attributeKey,
  attributeValue,
  removeAttributeOutside,
  options
) {
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        options.callback
          ? options.callback(observedElement)
          : entry.target.setAttribute(attributeKey, attributeValue);
        if (!removeAttributeOutside) {
          observer.unobserve(entry.target);
        }
      } else {
        entry.target.removeAttribute(attributeKey);
      }
    });
  }, options);
  observer.observe(observedElement);
}

/**
 * Add active class when element is in viewport
 *
 * @param {string|Array<Element>} observedElements proper Node list of ELement that should be observed
 * @param {string} attributeKey proper attribute key that should be added when the element is in viewport
 * @param {string} attributeValue proper attribute value that should be added when the element is in viewport
 * @param {boolean} removeAttributeOutside remove attribute when item is outside viewport. Default `false`
 * @param {{}} options for options {@link https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API}
 *
 * @note Passing observedElements as a string is deprecated. Please use an array of HTMLObjects instead.
 *
 * @returns {void}
 */
export function addInViewportAttribute(
  observedElements,
  attributeKey,
  attributeValue,
  removeAttributeOutside = false,
  options = {}
) {
  observedElements.forEach((observedElement) => {
    addObserver(
      observedElement,
      attributeKey,
      attributeValue,
      removeAttributeOutside,
      options
    );
  });
}
